module.exports = __webpack_public_path__ + "static/media/scale-design.8a35d849.png";